import { render, staticRenderFns } from "./tool-registry.vue?vue&type=template&id=4dc12128&scoped=true&"
import script from "./tool-registry.ts?vue&type=script&lang=ts&"
export * from "./tool-registry.ts?vue&type=script&lang=ts&"
import style0 from "./tool-registry.scss?vue&type=style&index=0&id=4dc12128&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc12128",
  null
  
)

export default component.exports